export const BidSource = {
  Reference: "reference",
  Modified: "modified",
  Current: "current"
};
